import { DraftAccount, DraftGroup } from "./draftOperations";
import { orderAccountsCanonically } from "./canonicalAccountOrder";
import { ChartOfAccountsTemplateEditorRow } from "./editorRowTypes";
import { resolveCustomGroupChain } from "./groupChain";

interface BuildEditorRowsParams {
    accounts: DraftAccount[];
    groups: DraftGroup[];
}

export const buildChartOfAccountsTemplateEditorRows = ({
    accounts,
    groups,
}: BuildEditorRowsParams): ChartOfAccountsTemplateEditorRow[] => {
    const groupsById = new Map(groups.map((group) => [group.id, group]));
    const orderedAccounts = orderAccountsCanonically({ accounts, groups });

    return orderedAccounts.map((account): ChartOfAccountsTemplateEditorRow => {
        const customChain = resolveCustomGroupChain(
            account.parentGroupId,
            groupsById,
        );
        return {
            id: account.id,
            account,
            codeText: account.codeText,
            name: account.name,
            type: account.type,
            tierLabels: customChain.names,
            customGroupChainIds: customChain.ids,
        };
    });
};
